import axios from "axios";

export const getHelper = async (helperID: any) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Helper/helper?HelperID=${helperID}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
